// src/core/constants.js — constantes públicas de producto.
//
// FASE 3.17 Bloque B — DT-CK cerrada: dominio definitivo del producto.
// Centraliza el host para que cualquier cambio de dominio sea 1 sola edición.

export const DOMINIO_PRODUCTO = 'pactomundial.futbol'

// URL absoluta del link viral de una arenga pública (compartible vía /t/AUDIO_ID).
export const buildArengaShareUrl = (audioId) => `https://${DOMINIO_PRODUCTO}/t/${audioId}`

// URL absoluta del link de invitación de un grupo (compartible vía /g/CODIGO).
export const buildGrupoShareUrl = (codigo) => `https://${DOMINIO_PRODUCTO}/g/${codigo}`
